import JsBarcode from "jsbarcode";
import QRCode from "qrcode";
const Zebra = {
  title: "Style 1 (Letter)",
  css: function () {
    return `@media print{@page{size:377.95275591px 566.92913386px;margin:2px;padding:0}}*{margin:0;padding:0}body{padding:2px}:root{--border-color:rgba(0,0,0,.9)}.report{height:793px}.zebra-container{position:relative;width:100%}.zebra-report{position:relative;width:540px;height:700px;border-width:1px;transform:scale(calc(377.9px / 540px) ,calc(566.92px / 700px));border:1px solid var(--border-color)}.content-row,.header-section>div,.section>div{border:1px solid var(--border-color)}.header-section,.multicolumn-content>.content-column:first-child div:not(:last-child){border-bottom:1px solid var(--border-color)}.header-section{position:relative;height:150px;display:flex}.header-section>div{display:flex;justify-content:center;align-items:center}.pickupdate{text-transform:capitalize;align-self:flex-start;margin-left:20px}.header-section .qr-code{width:170px;float:right}.header-section .left{width:calc(100% - 170px);flex-direction:column;justify-content:space-between;padding:10px 0}.section{display:grid;grid-template-columns:30px calc(100% - 30px)}.content-row{min-height:28.6px;display:grid;place-items:center}.large-row{min-height:88px}.large-field{min-height:58.6px}.contents{border-left:1px solid}.section .title{text-align:center;transform:rotate(180deg);display:grid;place-items:center;letter-spacing:.27px;font-family:sans-serif;font-weight:700;text-transform:capitalize;font-size:13pt}.section .title span{transform:rotate(90deg);position:absolute}.multicolumn-content,.shipment-content{display:grid;grid-template-columns:90px calc(100% - 90px)}.multicolumn-content .weight{border-bottom:none}.cod,.multicolumn-content>.content-column:first-child div,.phone>div,.pieces>div,.ref,.ref>div,.weight>div{border:none}.multicolumn-content>.content-column:last-child .content-row{border-top:none}.shipper-section .content-row{min-height:40px}.splitted-row{display:grid;grid-template-columns:225px calc(100% - 225px)}.splitted-row-twice{width:100%;display:grid;grid-template-columns:120px calc(100% - 120px)}.splitted-row-twice .content-row{place-items:unset;display:flex;align-items:center;justify-content:center;border:none;border-left:1px solid var(--border-color)}.splitted-row-twice .content-row:last-child{justify-content:center}`;
  },
  size: "letter",
  render: function (data, Courier) {
    const {
      AWB,
      ToCityName,
      ToCity,
      Peices,
      Pieces,
      ToAddress,
      ToConsigneeName,
      RecipientName,
      Telephone,
      SpecialInstruction,
      SpecialInstuctions,
      COD,
      ToRef,
      Weight,
      Pcs,
      ToMobile,
      Contents,
      Data1,
      AuditDate,
      Data2,
      Data3,
      Data4,
      PickupDate,
      ToPhone,
      ClientName,
    } = data;
    const { Notes } = Courier;
    const reportElement = document.createElement("div");
    reportElement.innerHTML = `
            <div class="report">
            <div class="zebra-container">
                <div class="zebra-report">
                    <div class="header-section">
                        <div class="left">
                        <svg id="barcode-${AWB}"></svg>
                            <div class="pickupdate">
                                pickup date ${
                                  PickupDate
                                    ? PickupDate?.slice(0, 10)
                                    : AuditDate?.slice(0, 10)
                                }
                            </div>
                        </div>
                        <div class="qr-code-${AWB}" >
                                
                        </div>
        
                    </div>
                    <div class="section shipper-section">
                        <div class="title">
                           <span> shipper </span>
                        </div>
                        <div class="content">
                            <div class="content-column">
                                <div class="content-row">${ClientName}</div>
                                <div class="content-row"></div>
                                <div class="content-row"></div>
                            </div>
                        </div>
                    </div>
                    <div class="section consignee-section">
                        <div class="title">
                           <span>Consignee</span> 
                        </div>
                        <div class="content multicolumn-content">
                            <div class="content-column">
                                <div class="content-row">City</div>
                                <div class="content-row large-field">Address</div>
                                <div class="content-row">Name</div>
                                <div class="content-row">Phone</div>
                                <div class="content-row">Ref</div>
                            </div>
                            <div class="content-column">
                                <div class="content-row">${
                                  ToCity ? ToCity : ToCityName
                                }</div>
                                <div class="content-row large-field">${ToAddress}</div>
                                <div class="content-row">${
                                  RecipientName
                                    ? RecipientName
                                    : ToConsigneeName
                                }</div>
                                <div class="content-row splitted-row phone">
                                    <div class="content-row phone1">${
                                      Telephone ? Telephone : ToMobile
                                    } </div>
                                    <div class="content-row phone2">${
                                      Telephone ? Telephone : ToPhone
                                    } </div>
                                </div>
                                <div class="content-row splitted-row weight">
                                    <div class="content-row ref">${
                                      ToRef ? ToRef : ""
                                    }</div>
                                    <div class=" splitted-row-twice">
                                        <div class="content-row">Weight</div>
                                        <div class="content-row">${Weight}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section shipment-section">
                        <div class="title">
                          <span>shipment</span>  
                        </div>
                        <div class="content">
                            <div class="multicolumn-content">
                                <div class="content-column">
                                    <div class="content-row">COD</div>
                                    <div class="content-row">Contents</div>
                                </div>
                                <div class="content-column">
                                        <div class="content-row splitted-row">
                                            <div class="content-row cod">${COD}</div>
                                            <div class=" splitted-row-twice ">
                                                <div class="content-row">Pieces</div>
                                                <div class="content-row">${
                                                  Pcs
                                                    ? Pcs
                                                    : Pieces
                                                    ? Pieces
                                                    : Peices
                                                }</div>
                                            </div>
                                        </div>
                                        <div class="content-row contents">
                                            ${
                                              SpecialInstruction
                                                ? SpecialInstruction
                                                : SpecialInstuctions
                                            }
                                        </div>
                                </div>
                            </div>
                            <div class="splitted-row">
                                <div class="content-row">${Data1}</div>
                                <div class="content-row">${Data2}</div>
                            </div>
                            <div class="splitted-row">
                                <div class="content-row">${Data3}</div>
                                <div class="content-row">${Data4}</div>
                            </div>
                            <div class="content-row large-row info">
                                ${Contents}
                            </div>
                            <div class="content-row"> ${
                              Notes ? Notes : ""
                            }</div>
        
                        </div>
                    </div>
                </div>
            </div>
        </div>
            `;
    JsBarcode(reportElement.querySelector("#barcode-" + AWB), AWB);

    QRCode.toCanvas(AWB, { width: 145, height: 145 }, function (err, canvas) {
      if (err) throw err;
      reportElement.querySelector(".qr-code-" + AWB).appendChild(canvas);
    });
    return reportElement;
  },
};
export default Zebra;
